import { z } from 'zod';
import { AIProviderSchema } from '../../canvas/node-models';

// Extended Provider ID Schema (includes mock)
// NOTE: This is now just an alias for AIProviderSchema for backward compatibility
export const AIProviderIdExtendedSchema = AIProviderSchema;
export type AIProviderIdExtended = z.infer<typeof AIProviderIdExtendedSchema>;

// Extended Provider Status Schema (includes maintenance)
export const AIProviderStatusExtendedSchema = z.enum(['active', 'inactive', 'maintenance']);
export type AIProviderStatusExtended = z.infer<typeof AIProviderStatusExtendedSchema>;

// Model Config
export const AIModelConfigSchema = z.object({
  type: z.enum(['text-to-text', 'text-to-image']),
  systemPrompt: z.string().optional(),
  parameters: z.record(z.string(), z.any()).optional(),
});
export type AIModelConfig = z.infer<typeof AIModelConfigSchema>;

// Provider Config
export const AIProviderConfigSchema = z.object({
  id: AIProviderIdExtendedSchema,
  name: z.string().min(1),
  status: AIProviderStatusExtendedSchema,
  apiKey: z.string(),
  endpoint: z.string().optional(), // Optional custom endpoint URL
  models: z.record(z.string(), AIModelConfigSchema),
});
export type AIProviderConfig = z.infer<typeof AIProviderConfigSchema>;

// Full AI Config
export const AIConfigSchema = z.object({
  providers: z.record(z.string(), AIProviderConfigSchema),
  modelToProvider: z.record(z.string(), z.string()),
  fallbackStrategy: z.record(z.string(), z.string().nullable()),
  userSelectableModels: z.array(z.string()),
});
export type AIConfig = z.infer<typeof AIConfigSchema>;
